import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "@/api/client";
import type {
  TeamAllowedModel,
  TeamAllowedModelsPut,
} from "@/api/types";

const KEY = (teamId: string) => ["team-allowed-models", teamId] as const;

export function useTeamAllowedModels(teamId: string) {
  return useQuery({
    queryKey: KEY(teamId),
    queryFn: () =>
      api.GET<TeamAllowedModel[]>(`/teams/${teamId}/allowed-models`),
    enabled: Boolean(teamId),
  });
}

export function useUpdateTeamAllowedModels(teamId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: TeamAllowedModelsPut) =>
      api.PUT<TeamAllowedModel[]>(
        `/teams/${teamId}/allowed-models`,
        payload,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY(teamId) });
    },
  });
}
